import type { APIClient } from '@src/shared/api';

import { useMutation } from '@src/shared/query';

export type PasswordResetRequestPayload = {
  email: string;
};

export type PasswordResetConfirmPayload = {
  password: string;
  otp_code: string;
  token: string;
};

type PasswordResetResponse = Record<string, unknown>;

export function usePasswordResetRequest() {
  return useMutation<PasswordResetResponse, Error, PasswordResetRequestPayload>(
    {
      mutationKey: ['auth', 'password-reset', 'request'],
      mutateFn: ({
        apiClient,
        ...payload
      }: { apiClient: APIClient } & Record<string, unknown>) => {
        return apiClient.request({
          url: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/password/reset/request/`,
          method: 'POST',
          payload,
          useAuth: false,
        }) as Promise<{ detail: string }>;
      },
    },
  );
}

export function usePasswordResetConfirm() {
  return useMutation<PasswordResetResponse, Error, PasswordResetConfirmPayload>(
    {
      mutationKey: ['auth', 'password-reset', 'confirm'],
      mutateFn: ({ apiClient, ...payload }) => {
        return apiClient.request({
          url: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/password/reset/confirm/`,
          method: 'POST',
          payload,
          useAuth: false,
        }) as Promise<{ detail: string }>;
      },
    },
  );
}
